import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Floating } from "@/components/Floating";
import { ApplyModal } from "@/components/ApplyModal";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import FleetPage from "@/pages/FleetPage";
import CessnaPage from "@/pages/CessnaPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  const [applyOpen, setApplyOpen] = useState(false);
  const openApply = () => setApplyOpen(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App bg-white">
      <Toaster position="top-center" richColors />
      <ScrollToTop />
      <Navbar onApply={openApply} />
      <main>
        <Routes>
          <Route path="/" element={<Home onApply={openApply} />} />
          <Route path="/about" element={<About onApply={openApply} />} />
          <Route path="/cessna" element={<CessnaPage onApply={openApply} />} />
          <Route path="/courses" element={<Courses onApply={openApply} />} />
          <Route path="/fleet" element={<FleetPage onApply={openApply} />} />
          <Route path="/faq" element={<FAQPage onApply={openApply} />} />
          <Route path="/contact" element={<ContactPage onApply={openApply} />} />
          <Route path="*" element={<Home onApply={openApply} />} />
        </Routes>
      </main>
      <Footer />
      <Floating onApply={openApply} />
      <ApplyModal open={applyOpen} onClose={() => setApplyOpen(false)} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
